import React from 'react';
import ReactTable from 'react-table';

import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Link } from 'react-router-dom';
import config from '../config';
import Sublogin from './elements/sublogin';

const defaultColumnWidth = 57;

import { TableComponent, connect } from './tableComponent';

const offers = {
  easysex: {
    name: 'Easy',
    minWidth: 45
  },
  chatsales: {
    name: 'HLink',
    minWidth: 45
  },
  hgh2: {
    name: 'Loans',
    minWidth: 45
  },
  // hg1: {
  //   name: '1Usd',
  //   minWidth: 45
  // },
  // andy: {
  //   name: "Andy",
  //   minWidth: 45
  // },
  andy1: {
    name: 'CupidS',
    minWidth: 45
  },
  // wellhello: {
  //   name: 'Hello',
  //   minWidth: 45,
  // },
  // chrissales: {
  //   name: 'Ch',
  //   minWidth: 40,
  // },
  // cevip: {
  //   name: 'Cvip',
  //   minWidth: 40
  // },
  cupid: {
    name: 'Cupid',
    minWidth: 45
  },
  loc: {
    name: 'Cupid3',
    minWidth: 45
  },
  // sexplaycam: {
  //   name: 'LCash',
  //   minWidth: 50
  // },
  imlive: {
    name: 'Live',
    minWidth: 45
  },
  spice: {
    name: 'Spice',
    minWidth: 45
  },
  sandra_sales: {
    name: 'Cams',
    minWidth: 45
  },
  // hookupbay: {
  //   name: 'HBay',
  //   minWidth: 45
  // },
  dgold: {
    name: 'DGold',
    minWidth: 45
  },
  punk: {
    name: 'Punk',
    minWidth: 45
  },
  punk1: {
    name: 'Pnk1',
    minWidth: 45
  },
  // sms_chat: {
  //   name: 'SBot',
  //   minWidth: 40
  // }
  // andy30: {
  //   name: 'Ap',
  //   minWidth: 40
  // },
  // andy60: {
  //   name: 'Ac',
  //   minWidth: 40
  // }
  // sms: {
  //   name: 'SMS',
  //   minWidth: 40,
  //   suboffers: [
  //     {
  //       offer: 'sms_chatsales',
  //       name: 'HLink',
  //     },
  //     {
  //       offer: 'sms_sexplaycam',
  //       name: 'LCash',
  //     },
  //     {
  //       offer: 'sms_easysex',
  //       name: 'Easy',
  //     },
  //   ],
  //   // noInput: true
  // },
};

class Component extends TableComponent {
  initialState = {
    type: 'affiliates'
  };

  state = this.initialState;

  componentWillMount2 = () => {
    console.log('componentWillMount2');
    if (this.props.user.role_id >= 4) {
      this.props.api('master/get_agentsenabled').then((res) => {
        console.log('master/get_agentsenabled res', res);
        this.props.setState({ agents_enabled: parseInt(res.result) });
      });
    }
  };

  toggleAgents = () => {
    console.log('toggleAgents prevValue', this.props.state.agents_enabled);
    if (this.props.setAgentsEnabledState.loading || this.props.getAgentsEnabledState.loading) {
      return console.log('toggleAgents still loading, prevent change');
    }
    let prevValue = parseInt(this.props.state.agents_enabled || 0);
    let newValue = prevValue ? '0' : '1';
    this.props.setState({ agents_enabled: parseInt(newValue) });
    console.log('set_agentsenabled', { prevValue, newValue });
    this.props.api('master/set_agentsenabled', { value: newValue }).then((res) => {
      console.log('master/set_agentsenabled res', res);
      this.fetchData({ forceReload: true });
    });
  };

  affiliateCell = (props) => {
    // let props = this.props.p || this.props;
    var { id, noInput, noButton, notEarnings, suboffers } = props.column;
    var inputKey = notEarnings ? id : id + '_earnings';
    if (props.column.inputKey) inputKey = props.column.inputKey;
    if (inputKey == 'master_wid' && this.props.state.type == 'agents') {
      inputKey = 'owner_wid';
    }
    if (inputKey == 'spice_earnings') {
      inputKey = 'chatsales_earnings';
    }
    let inputValue = props.original[inputKey];
    if (typeof inputValue == 'undefined') {
      var noInput = true;
    }

    let buttonKey = props.column.buttonKey ? props.column.buttonKey : id;
    let enabled = props.original[buttonKey] == 1;
    var max = 10000000;
    if (
      this.props.user.role_id < 4 &&
      inputKey.indexOf('earning') != -1 &&
      typeof this.props.user[inputKey] != 'undefined'
    ) {
      max = this.props.user[inputKey];
    }
    if (!enabled && inputKey != 'master_chat_earnings') {
      noInput = true;
    }
    return (
      <div class='affiliate-cell'>
        {!noButton && (
          <button
            type='button'
            class={'btn btn-sm btn-block btn-aff-toggle ' + (enabled ? 'warning' : 'white')}
            onClick={(e) => {
              this.handleToggleData(!enabled, props, buttonKey);
            }}
          >
            {enabled ? 'On' : 'Off'}
          </button>
        )}
        {enabled &&
          suboffers &&
          suboffers.map((suboffer) => {
            let subofferEnabled = props.original[suboffer.offer] == 1;
            return (
              <div key={suboffer.offer}>
                <button
                  type='button'
                  class={
                    'btn btn-sm btn-block btn-aff-toggle ' + (subofferEnabled ? 'warning' : 'white')
                  }
                  onClick={(e) => {
                    this.handleToggleData(!subofferEnabled, props, suboffer.offer);
                  }}
                >
                  {suboffer.name}
                </button>
              </div>
            );
          })}
        {!noInput && (
          <div>
            <input
              type='number'
              class={'form-control form-control-sm affiliates-input ' + (noButton ? '' : 'mt-1')}
              min='0'
              max={max}
              value={inputValue}
              onChange={(e) => {
                this.handleChangeData(e.target.value, props, inputKey);
              }}
              onBlur={(e) => {
                this.handleSubmitData(props, inputKey);
              }}
            />
          </div>
        )}
      </div>
    );
  };

  makeColumns = () => {
    var columns = [];
    let isAdmin = this.props.user.role_id >= 3;
    if (isAdmin) {
      columns = [
        {
          Header: 'Wid',
          accessor: 'aid',
          minWidth: 50,
          className: 'text-center',
          Cell: (props) => {
            let inputKey = this.type == 'agents' ? 'owner_wid' : 'master_wid';
            return (
              <div>
                <div>{props.value}</div>
                <div>
                  <input
                    type='text'
                    class={'form-control form-control-sm affiliates-input mt-1 text-center'}
                    value={props.original[inputKey]}
                    onChange={(e) => {
                      this.handleChangeData(e.target.value, props, inputKey);
                    }}
                    onBlur={(e) => {
                      this.handleSubmitData(props, inputKey);
                    }}
                  />
                </div>
              </div>
            );
          },
          Footer: (props) => <b>{this.props.total.count || 0}</b>
        },
        {
          Header: 'Name/Skype/Mail',
          id: 'name',
          style: { overflow: 'hidden' },
          minWidth: 120,
          accessor: (d) => d.firstname + ' ' + d.lastname,
          Cell: (props) => (
            <div>
              <div>{props.value}</div>
              <div>{props.original.skype}</div>
              <div>{props.original.email != props.original.skype ? props.original.email : ''}</div>
            </div>
          ),
          Footer: (props) => <div class='pull-right mr-2'>{this.props.total.sales || 0} sales</div>
        },
        {
          Header: '$ / Reg',
          accessor: 'total_earnings',
          minWidth: 85,
          className: 'text-center',
          Cell: (props) => (
            <div>
              $ {props.value} <br /> {props.original.total_sales} sales <br /> {props.original.date}{' '}
            </div>
          ),
          Footer: (props) => <div>$ {this.props.total.earned || 0}</div>
        },
        {
          Header: 'Flagged',
          accessor: 'frauds',
          minWidth: 55,
          className: 'text-center',
          Cell: (props) => <div>{props.value}</div>
        },
        {
          Header: 'Master',
          accessor: 'master_chat_earnings',
          inputKey: 'master_chat_earnings',
          buttonKey: 'is_subadmin',
          minWidth: 55,
          noButton: false,
          notEarnings: true,
          Cell: this.affiliateCell
        },
        {
          Header: 'Pro',
          accessor: 'isPro',
          inputKey: 'isPro',
          buttonKey: 'isPro',
          minWidth: 55,
          noButton: false,
          notEarnings: true,
          noInput: true,
          Cell: this.affiliateCell
        },
        {
          Header: 'PBack',
          accessor: 'postback_on',
          buttonKey: 'postback_on',
          minWidth: 50,
          noInput: true,
          notEarnings: true,
          Cell: this.affiliateCell
        },
        {
          Header: 'Agents',
          accessor: 'agents_enabled',
          buttonKey: 'agents_enabled',
          minWidth: 50,
          noInput: true,
          notEarnings: true,
          Cell: this.affiliateCell
        },
        {
          Header: 'Active',
          accessor: 'active',
          minWidth: defaultColumnWidth,
          noInput: true,
          minWidth: 55,
          Cell: (props) => {
            return (
              <div>
                <div>
                  <button
                    type='button'
                    class={
                      'btn btn-sm btn-block p-0 btn-aff-toggle ' +
                      (props.original.active ? 'warning' : 'white')
                    }
                    onClick={(e) => {
                      this.handleToggleData(!props.original.active, props, 'active');
                    }}
                  >
                    Active
                  </button>
                </div>
                <div>
                  <Sublogin aid={props.original.aid} class='p-0 mt-1' />
                </div>

                <div>
                  <Link
                    class='btn btn-sm btn-block success mt-1 p-0'
                    to={config.basePath + '/affiliate/' + props.original.aid + '/sales'}
                  >
                    Sales
                  </Link>
                </div>
              </div>
            );
          }
        }
      ];
      var i = 0;
      for (let offerId in offers) {
        let { name, minWidth, suboffers, noInput } = offers[offerId];
        columns.splice(6 + i, 0, {
          Header: name,
          accessor: offerId,
          minWidth: minWidth || defaultColumnWidth,
          // style: {padding: "7px 1px"},
          suboffers: suboffers,
          noInput: noInput,
          Cell: this.affiliateCell
        });
        i++;
      }
    } else {
      columns = [
        {
          Header: 'Wid',
          accessor: 'aid',
          minWidth: 50,
          className: 'text-center',
          Footer: (props) => <b>Total</b>
        },
        {
          Header: 'Name/Skype',
          id: 'name',
          minWidth: 160,
          accessor: (d) => d.firstname + ' ' + d.lastname,
          Cell: (props) => (
            <div>
              {props.value} <br /> {props.original.skype}
            </div>
          ),
          Footer: (props) => <b>{this.props.total.count || 0}</b>
        },
        {
          Header: 'Email / Reg.date',
          accessor: 'date',
          minWidth: 160,
          Cell: (props) => (
            <div>
              {props.original.email}
              <br />
              {props.value}
            </div>
          ),
          Footer: (props) => <div class='pull-right mr-2'>{this.props.total['sales']} sales</div>
        },
        {
          Header: 'Money',
          accessor: 'total_earnings',
          minWidth: 77,
          Cell: (props) => (
            <div>
              $ {props.value} <br /> {props.original.total_sales} sales{' '}
            </div>
          ),
          Footer: (props) => <div>$ {this.props.total['earned']}</div>
        },
        {
          Header: 'Active',
          accessor: 'active',
          minWidth: 55,
          noInput: true,
          Cell: this.affiliateCell
        },
        {
          Header: '',
          id: 'login',
          accessor: 'aid',
          sortable: false,
          minWidth: 60,
          Cell: (props) => {
            return (
              <div class='affiliate-cell'>
                <div>
                  <Sublogin aid={props.value} />
                </div>
                <div>
                  <Link
                    class='btn btn-sm btn-block warning mt-1'
                    to={config.basePath + '/affiliate/' + props.value + '/sales'}
                  >
                    Sales
                  </Link>
                </div>
              </div>
            );
          }
        }
      ];
      let userOffers = this.props.user.offers.filter((offer) => offer != 'gaylinks');
      for (var i = 0; i < userOffers.length; i++) {
        let offerId = userOffers[i];
        if (offers[offerId]) {
          columns.splice(4 + i, 0, {
            Header: offers[offerId].name,
            accessor: offerId,
            minWidth: offers[offerId].minWidth || defaultColumnWidth,
            // style: {padding: "7px 1px"},
            Cell: this.affiliateCell
          });
        } else {
          console.log('offer not found:', offerId);
        }
      }
      if (this.props.user.isPro) {
        columns.splice(columns.length - 2, 0, {
          Header: 'Pro',
          accessor: 'isPro',
          inputKey: 'isPro',
          buttonKey: 'isPro',
          minWidth: 55,
          noButton: false,
          notEarnings: true,
          noInput: true,
          Cell: this.affiliateCell
        });
      }
    }
    return columns;
  };

  apiPath = 'affiliates/load';
  editApiPath = 'affiliates/edit';

  fetchParams = (state) => {
    return {
      type: this.props.state.type || 'affiliates'
    };
  };

  tableParams = {
    manual: true,
    sorted: [
      {
        id: 'aid',
        desc: true
      }
    ],
    defaultPageSize: 50
  };

  render() {
    let agentsEnabled = parseInt(this.props.state.agents_enabled || 0);
    let isSuperAdmin = this.props.user.role_id >= 4;
    return (
      <div class='affiliates-page'>
        <div class='row'>
          <div class='col-sm'>
            {this.props.user.role_id >= 3 && (
              <div class='btn-group'>
                {this.typeButton('Admins', 'admins')}
                {this.typeButton('Masters', 'masters')}
                {this.typeButton('Affiliates', 'affiliates')}
                {this.typeButton('Agents', 'agents')}
                {false && this.typeButton('Banned', 'banned')}
              </div>
            )}
          </div>
          <div class='col-sm'>
            {this.props.error && <div>Error: {this.props.error.toString()}</div>}
            {this.props.apiChangeState.error && (
              <div>Error: {this.props.apiChangeState.error.toString()}</div>
            )}
            {this.props.apiChangeState.data.result == 0 && <div>Error: not saved</div>}
          </div>
          <div class='col-sm'>
            {this.searchElement()}
            <div class='affiliates-header-toggles pull-right mr-2'>
              {isSuperAdmin && !this.props.getAgentsEnabledState.loading && (
                <button
                  type='button'
                  class={
                    'btn btn-sm btn-block btn-aff-toggle ' + (agentsEnabled ? 'warning' : 'white')
                  }
                  onClick={(e) => {
                    this.toggleAgents('agents_enabled', !agentsEnabled);
                  }}
                >
                  Agents
                </button>
              )}
            </div>
          </div>
        </div>
        <div class='row'>
          <div class='col-12'>
            <div class='box mt-2'>{this.reactTable()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component, 'affiliates_load', function (state) {
  return {
    apiChangeState: state.api.affiliates_edit || state.api.initial,
    getAgentsEnabledState: state.api.master_get_agentsenabled || state.api.initial,
    setAgentsEnabledState: state.api.master_set_agentsenabled || state.api.initial
  };
});
